import * as React from 'react';
import { createInstance } from '@module-federation/enhanced/runtime';
import ReactDOM from 'react-dom';
import * as ReactRouterDOM from 'react-router-dom';
import LoadingSpinner from './components/LoadingSpinner';

const mf = createInstance({
  name: 'host',
  remotes: [
    {
      name: 'encore-outbound',
      entry:
        'https://dev.encore-outbound.encore-product-apps.locus-dev.com/mf-manifest.json',
    },
  ],
  shared: {
    react: {
      version: '19.1.0',
      scope: 'default',
      lib: () => React,
      shareConfig: {
        singleton: true,
        requiredVersion: '^19.1.0',
      },
    },
    'react-dom': {
      version: '19.1.0',
      scope: 'default',
      lib: () => ReactDOM,
      shareConfig: {
        singleton: true,
        requiredVersion: '^19.1.0',
      },
    },
    'react-router-dom': {
      version: '7.6.3',
      scope: 'default',
      lib: () => ReactRouterDOM,
      shareConfig: {
        singleton: true,
        requiredVersion: '^7.6.3',
      },
    },
  },
});

export const OutboundContainer = () => {
  const OutboundMfe = React.lazy(() => {
    try {
      return mf
        .loadRemote('encore-outbound/App')
        .then((value: any) => {
          const { default: DefaultExport } = value;
          const Component = DefaultExport;
          return {
            default: Component,
          };
        })
        .catch(error => {
          throw error;
        });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in loadRemote call:', error);
      throw error;
    }
  });

  return (
    <React.Suspense fallback={<LoadingSpinner />}>
      <OutboundMfe />
    </React.Suspense>
  );
};
